export default "__VITE_ASSET__ClaYQCSS__"